import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const PageTitle = styled.h1`
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.fonts.title};
    font-size: 28px;
`;

export const StyledWrapper = styled(FlexBox)`
    width: 100%;
    padding: 32px 0;

    ${media.sm`
        padding: 35px 0;
  `}

    ${media.sm`
        padding: 35px 0;
  `}
`;

export const StyledBorder = styled(FlexBox)`
    width: 100%;
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.gs400}`};
`;